var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GraphQLNonEmptyString, GraphQLNonNegativeInt, GraphQLPositiveInt, } from "graphql-scalars";
import { ArgsType, Field, InputType, registerEnumType } from "type-graphql";
import { createFilterGroup } from "./Filter.js";
import { DEFAULT_PAGE_SIZE, FIRST_PAGE, SortDirection, } from "./ListQueryTypes.js";
let AbstractSortItem = class AbstractSortItem {
    field;
    direction;
};
__decorate([
    Field(() => SortDirection, {
        defaultValue: SortDirection.asc,
        nullable: false,
    }),
    __metadata("design:type", String)
], AbstractSortItem.prototype, "direction", void 0);
AbstractSortItem = __decorate([
    InputType()
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-parameters
], AbstractSortItem);
export { AbstractSortItem };
export function SortItem(resolverName, fieldsEnum) {
    let Sort = class Sort extends AbstractSortItem {
    };
    __decorate([
        Field(() => fieldsEnum, { nullable: false }),
        __metadata("design:type", String)
    ], Sort.prototype, "field", void 0);
    Sort = __decorate([
        InputType(`${resolverName}Sort`)
    ], Sort);
    return Sort;
}
let AbstractSearchFilter = class AbstractSearchFilter {
};
__decorate([
    Field(() => GraphQLNonEmptyString, {
        nullable: false,
    }),
    __metadata("design:type", String)
], AbstractSearchFilter.prototype, "query", void 0);
AbstractSearchFilter = __decorate([
    InputType()
], AbstractSearchFilter);
export { AbstractSearchFilter };
export function SearchFilter(resolverName, fieldsEnum) {
    let SearchFilter = class SearchFilter extends AbstractSearchFilter {
    };
    __decorate([
        Field(() => [fieldsEnum], {
            nullable: true,
            description: "The fields to search in. If unspecified, searches all searchable fields. Note that searching by a field that does not support it will cause a runtime error",
        }),
        __metadata("design:type", Object)
    ], SearchFilter.prototype, "fields", void 0);
    SearchFilter = __decorate([
        InputType(`${resolverName}SearchFilter`)
    ], SearchFilter);
    return SearchFilter;
}
let AbstractFilteredListQueryArgs = class AbstractFilteredListQueryArgs {
    filters;
    sortBy;
    search;
    sendAll = false;
    get offset() {
        if (this.sendAll) {
            return 0;
        }
        return (this.page - 1) * this.pageSize;
    }
    get limit() {
        if (this.sendAll) {
            return undefined;
        }
        return this.pageSize;
    }
};
__decorate([
    Field(() => Boolean, {
        nullable: true,
        description: "Whether to send all results in a single page, defaults to false (should generally be avoided)",
        defaultValue: false,
    }),
    __metadata("design:type", Object)
], AbstractFilteredListQueryArgs.prototype, "sendAll", void 0);
__decorate([
    Field(() => GraphQLNonNegativeInt, {
        nullable: true,
        description: `The number of items to return per page, defaults to ${String(DEFAULT_PAGE_SIZE)}`,
        defaultValue: DEFAULT_PAGE_SIZE,
    }),
    __metadata("design:type", Number)
], AbstractFilteredListQueryArgs.prototype, "pageSize", void 0);
__decorate([
    Field(() => GraphQLPositiveInt, {
        nullable: true,
        description: `The page number to return, defaults to ${String(FIRST_PAGE)}`,
        defaultValue: FIRST_PAGE,
    }),
    __metadata("design:type", Number)
], AbstractFilteredListQueryArgs.prototype, "page", void 0);
AbstractFilteredListQueryArgs = __decorate([
    ArgsType()
], AbstractFilteredListQueryArgs);
export { AbstractFilteredListQueryArgs };
export function FilteredListQueryArgs(resolverName, fields = []) {
    const FilterKeysEnum = Object.fromEntries(fields.map((v) => [v, v]));
    registerEnumType(FilterKeysEnum, {
        name: `${resolverName}FilterFields`,
    });
    const FilterGroup = createFilterGroup(FilterKeysEnum, resolverName);
    const Sort = SortItem(resolverName, FilterKeysEnum);
    const Search = SearchFilter(resolverName, FilterKeysEnum);
    let FilteredListQueryArgs = class FilteredListQueryArgs extends AbstractFilteredListQueryArgs {
    };
    __decorate([
        Field(() => FilterGroup, { nullable: true }),
        __metadata("design:type", void 0)
    ], FilteredListQueryArgs.prototype, "filters", void 0);
    __decorate([
        Field(() => [Sort], {
            nullable: true,
            description: "The fields to sort by, in order of priority. If unspecified, the sort order is undefined",
        }),
        __metadata("design:type", Object)
    ], FilteredListQueryArgs.prototype, "sortBy", void 0);
    __decorate([
        Field(() => Search, { nullable: true }),
        __metadata("design:type", void 0)
    ], FilteredListQueryArgs.prototype, "search", void 0);
    FilteredListQueryArgs = __decorate([
        ArgsType()
    ], FilteredListQueryArgs);
    return FilteredListQueryArgs;
}
//# sourceMappingURL=FilteredListQueryArgs.js.map